import { useEffect, useState } from 'react'
import fetch from 'isomorphic-unfetch'

export const PACKAGE_DISPLAY_MINIMUM = 3
const PACKAGE_PRICE_CACHE_ENDPOINT = '/pws/v0/psapi/search/pricecache'

const setDealContent = deals => {
  return deals.map(deal => {
    return {
      ...deal,
      id: `PACKAGE_DEAL_${deal.cityName.slice(-2)}`,
      image: deal.cityImageUrl,
      imageHeight: '284px',
      gaCategory: 'PACKAGES_LANDING',
      gaAction: 'Cached Deal',
      strikePrice:
        deal.priceAmount < deal.retailPriceAmount ? deal.retailPriceAmount : 0,
      gaLabel: deal.cityName,
      navArray: [
        {
          href: deal.searchLink,
          target: '_blank'
        }
      ]
    }
  })
}

const useFetchPackages = ({ latitude, longitude }) => {
  const queryString =
    latitude && longitude ? `?latitude=${latitude}&longitude=${longitude}` : ''
  const url = `${PACKAGE_PRICE_CACHE_ENDPOINT}${queryString}`
  const [deals, setDeals] = useState([])
  const [didFetchSucceed, setFetchSucceeded] = useState(true)

  useEffect(() => {
    const fetchPackageDeals = async () => {
      try {
        const priceCacheRespone = await fetch(url, {
          headers: {
            'Cache-Control': 'private, max-age=900'
          }
        })
        const priceCacheJson = await priceCacheRespone.json()
        const { packages = [] } = priceCacheJson

        if (
          !Array.isArray(packages) ||
          packages.length < PACKAGE_DISPLAY_MINIMUM
        ) {
          throw new Error('API call failed or not enough packages to display')
        }
        setFetchSucceeded(true)
        const packageDeals = setDealContent(packages)
        setDeals(packageDeals)
      } catch (err) {
        setFetchSucceeded(false)
        // TODO: log error to splunk once analytics are set up
      }
    }
    fetchPackageDeals()
  }, [url])

  return { deals, didFetchSucceed }
}

export default useFetchPackages
